<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm($event)" (cancel)="cancel($event)" (alt)="alt($event)">
  <div class="spacing--margin-top">
    <div data-test="order-line-dialog-product">
      <mat-form-field class="full-width-field">
        <mat-label>{{ 'product' | translate }}</mat-label>
        <input
          type="text"
          [placeholder]="'product' | translate"
          matInput
          [formControl]="cropAidId"
          [matAutocomplete]="cropAidAutocomplete"
          class="form"
          data-test="order-line-dialog-product-select"
        />
        <mat-autocomplete #cropAidAutocomplete="matAutocomplete" [displayWith]="displayCropAid()">
          @for (option of filteredCropAids$ | async; track option) {
            <mat-option [value]="option.id" data-test="order-line-dialog-product-option">
              {{ option.name }}
              {{ option.codes.length > 0 ? '(' + option.codes.join(', ') + ')' : '' }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
    @if ((areCropAidAndPackageActive$ | async) === false) {
      <div class="notification notification-error">
        <mat-icon>error</mat-icon>
        {{ 'inactivePackage' | switchTranslation }}
      </div>
    }
    @if ((selectedCropAid$ | async) && !availablePackages?.length) {
      <div class="notification notification-error">
        <mat-icon>error</mat-icon>
        {{ (isOneSapCropAid ? 'noPackages' : 'notOrderable') | translate }}
      </div>
    }
    @if ((selectedCropAid$ | async) && availablePackages?.length) {
      <div data-test="order-line-dialog-data">
        @if (isPeriodExpired$ | async) {
          <div class="notification notification-error">
            <mat-icon>error</mat-icon>
            {{ 'expiredPeriod' | switchTranslation }}
          </div>
        }
        @if ((isPeriodExpired$ | async) === false && !(periods$ | async).length) {
          <div class="notification notification-warning">
            <mat-icon>warning</mat-icon>
            {{ 'noDeliveryPeriodsForCurrentSettings' | switchTranslation }}
          </div>
        }
        <div>
          <mat-form-field class="full-width-field">
            <mat-label>{{ 'period' | translate }}</mat-label>
            <mat-select formControlName="periodId" [placeholder]="'period' | translate" data-test="order-line-dialog-period">
              @for (period of periods$ | async; track period) {
                <mat-option [value]="period.id" data-test="order-line-dialog-period-option">{{ period.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="full-width-field">
            <mat-label>{{ 'package' | translate }}</mat-label>
            <mat-select formControlName="packageId" [placeholder]="'package' | translate" data-test="order-line-dialog-package">
              @for (package of availablePackages; track package) {
                <mat-option [value]="package.id" data-test="order-line-dialog-package-option">
                  {{ package.amount | agrNumber }} {{ package.unitOfMeasurement }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if ((areCropAidAndPackageActive$ | async) === true) {
          <div class="text-color--gray2 spacing--margin-negative-top spacing--padding-bottom">
            <mat-label>{{ (selectedPackage$ | async)?.name }}</mat-label>
          </div>
        }
        <div>
          <mat-form-field class="full-width-field">
            <mat-label>{{ 'count' | translate }}</mat-label>
            <input maxlength="7" matInput agrNumber [placeholder]="'count' | translate" formControlName="count" data-test="order-line-dialog-count" />
          </mat-form-field>
        </div>
      </div>
    }
  </div>
</agr-form-dialog>
